import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  constructor(private http: HttpClient) { }


  getCountries() {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.COUNTRIES.GET_COUNTRIES;

    return this.http.get(url);

  }


}
